import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'discount'
})
export class DiscountPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    const price = args.discount ? args.CardStoreSalesPrice - (args.CardStoreSalesPrice * args.discount / 100) : args.CardStoreSalesPrice;
    return price
  }

}
